/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignRefDataSchema = z.object({
	id: z.string(),
	title: z.string(),
})

export type CampaignRefDataSchema = z.infer<typeof campaignRefDataSchema>
